import TemplateView from '../../../../../../js/TemplateView'
import {FEEDS_TOOLTIP_EXTRA_CLASS, RENDER_LEAVE_TYPES_LIMIT} from '../../../constants'
import LeaveTypeIcon from './LeaveTypeIcon'
import {escapeHtmlSymbols} from '../../../../../../js/atUtils'
import tooltip from '../../../../../../js/SimpleSingletonTooltip'

export default class FeedLeaveTypesSelection extends TemplateView {
    constructor({
        leaveTypes,
    }) {
        super()
        this.params = {
            leaveTypes,
        }
    }

    templateHtml() {
        return `<div class='leaveTypeSelection'>
                    <div class='emptyText'>
                        <%=emptyText%>
                    </div>
                    <div class='icons'/>
                    <div class='counter'/>
                </div>`
    }

    messageKeys() {
        return {
            emptyText: 'icalendar.page.table.leave_types.none'
        }
    }

    afterRender() {
        const leaveTypesAmount = this.params.leaveTypes.length
        this.find('.emptyText').toggle(leaveTypesAmount === 0)

        if (leaveTypesAmount > RENDER_LEAVE_TYPES_LIMIT)
            this.find('.counter').text(`+${leaveTypesAmount - RENDER_LEAVE_TYPES_LIMIT}`)

        this.params.leaveTypes.slice(0, RENDER_LEAVE_TYPES_LIMIT).forEach(leaveType => {
            new LeaveTypeIcon({
                id: leaveType.id,
                iconId: leaveType.iconId,
                name: leaveType.name,
            }).init(this.find('.icons'))
        })

        if (leaveTypesAmount > RENDER_LEAVE_TYPES_LIMIT) {

            let tooltipContent = this.params.leaveTypes
                                     .slice(RENDER_LEAVE_TYPES_LIMIT, leaveTypesAmount)
                                     .map(leaveType => `<div>${escapeHtmlSymbols(leaveType.name)}</div>`)
                                     .join('')

            tooltip(this.find('.counter'), {
                html: tooltipContent,
                extraClass: FEEDS_TOOLTIP_EXTRA_CLASS
            })
        }
    }
}


// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/FeedLeaveTypesSelection.js